import { addEventProcessor } from '@sentry/core';
/** Default EventOrigin instrumentation */
export class EventOrigin {
    constructor() {
        /**
         * @inheritDoc
         */
        this.name = EventOrigin.id;
    }
    /**
     * @inheritDoc
     */
    setupOnce() {
        addEventProcessor((event) => {
            var _a;
            event.tags = (_a = event.tags) !== null && _a !== void 0 ? _a : {};
            event.tags['event.origin'] = 'cordova';
            event.tags['event.environment'] = 'javascript';
            return event;
        });
    }
}
/**
 * @inheritDoc
 */
EventOrigin.id = 'EventOrigin';
